import { FieldTypes, UiFormField } from '../../utils/CommonTypes/UserTypes';
import { countWords } from '../../utils/wordCount';
import { isFieldVisible } from './FormSection';

export const fieldPlainText = (field: UiFormField, formValues: Record<string, string[]>) => {
    if (Object.prototype.hasOwnProperty.call(formValues, field.Key)) {
        return formValues[field.Key]?.[0] ?? '';
    }
    return field.Value?.[0] ?? '';
};

/** MinWords of 0 or missing means no word minimum. Hidden and read-only fields are skipped. */
export const isFieldWordCountSatisfied = (field: UiFormField, formValues: Record<string, string[]>, allFields?: UiFormField[]) => {
    const min = field.MinWords ?? 0;
    if (min < 1 || !field.Show || field.ReadOnly) return true;
    if (field.DependsOnKey && allFields && !isFieldVisible(field, formValues, allFields)) return true;
    return countWords(fieldPlainText(field, formValues)) >= min;
};

export const isFieldRegexSatisfied = (field: UiFormField, formValues: Record<string, string[]>) => {
    if (!field.ValidationRegularExpression) return true;

    let value = field.Value ? field.Value[0] : null;
    if (formValues[field.Key] && formValues[field.Key][0]) value = formValues[field.Key][0];

    if (!value) return true;

    var regex = new RegExp(field.ValidationRegularExpression, `g`);
    if (regex && value.match(regex)) return true;
    else return false;
};

export const isFieldSatisfied = (field: UiFormField, formValues: Record<string, string[]>, allFields?: UiFormField[]) => {
    if (!field.Required || !field.Show) return true;
    if (field.DependsOnKey && allFields && !isFieldVisible(field, formValues, allFields)) return true;
    if (field.Type === FieldTypes.Alert || field.Type === FieldTypes.AlertInfo || field.Type === FieldTypes.Header) return true;

    if (field.Type === FieldTypes.ReCaptcha) {
        let w: any = window;
        let value = w.x_reCaptcha;
        if (value) {
            formValues[field.Key] = [value, 'Added By Extra...'];
        }
        console.log('reCaptcah Value', value);
    }

    if (field.Type === FieldTypes.Checkbox) {
        //must be true...
        if (formValues[field.Key]) {
            //new value set, is this value valid?
            if (formValues[field.Key]?.find((x) => x === 'true' || x === 'True')) return true;
            return false;
        }
        const stored = field.Value?.[0];
        if (stored && stored.toLowerCase() === 'true') return true;
        return false;
    }
    if (field.Type === FieldTypes.ProfileImage || field.Type === FieldTypes.ProjectFile || field.Type === FieldTypes.AudioClip) {
        if (field.Files && field.Files.length > 0) return true;
    }
    if (formValues[field.Key]) {
        //new value set, is this value valid?
        if (formValues[field.Key]?.find((x) => x)) return true;
        else return false;
    }
    if (field.Value && field.Value[0]) return true;
    return false;
};

const firstValue = (values?: string[]) => values?.[0] ?? '';

/** Loaded value is still what the user would submit — confirm is only for a new/changed primary. */
export const isPrimaryUnchanged = (field: UiFormField, formValues: Record<string, string[]>) => {
    const original = firstValue(field.Value);
    if (!original) return false;
    if (!Object.prototype.hasOwnProperty.call(formValues, field.Key)) return true;
    return firstValue(formValues[field.Key]) === original;
};

export const isConfirmSatisfied = (field: UiFormField, formValues: Record<string, string[]>) => {
    if (!field.Confirm) return true;
    if (isPrimaryUnchanged(field, formValues)) return true;

    const current = firstValue(formValues[field.Key]) || firstValue(field.Value);
    const confirm = firstValue(formValues[field.Key + 'confirm']);
    if (!current) return true;
    return confirm === current;
};
